import {
  getAvailableBackUpBidAmount,
  getBestBid,
  getBuyerBidsCountered,
  getBuyerPremium,
  getPlaceBestBidDetails,
  submitPlaceBestBidResponse,
} from "@/api/bidDepositApiHold";
import React, { useState, useEffect, useMemo } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { useSelector } from "react-redux";
import "./PlaceBestBidModal.css";
import BackupBidSection from "./BestBackupBidHoldsection";
import { trackApiCall, trackButtonClick, trackEvent } from "@/utils/analytics";
import { getPropertyType } from "@/utils/propCategory";

const BestBidModal = ({ show, onHide, bidCenterData, userData, onSubmit }) => {
  const [bidAmount, setBidAmount] = useState("");
  const [holdAsBackup, setHoldAsBackup] = useState(null);
  const [backupDuration, setBackupDuration] = useState("");
  const [isValidating, setIsValidating] = useState(false);
  const [validationError, setValidationError] = useState("");
  const [previousShowState, setPreviousShowState] = useState(false);
  const [buyerBidsUser, setBuyerBidsUser] = useState();
  const [nextBid, setNextBid] = useState();
  const [inputType, setInputType] = useState("number"); // To switch between number and text type
  const [displayBidAmount, setDisplayBidAmount] = useState(""); // For displaying formatted value
  const [buyersPremium, setBuyersPremium] = useState({
    buyerPremiumFormatted: "-",
    totalDueFormatted: "-",
    percentageFormatted: "-",
  });
  const [possibleAmount, setPossibleAmount] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const user = useSelector((state) => state?.user?.user);
  const bestBid = useSelector((state) => state?.pdp?.bidCenterData);
  // console.log("propcategoryid", bestBid?.propCategoryId);

  const sellerId = useSelector(
    (state) => state?.pdp?.pdpInitData?.propertyDetails?.sellerId,
  );

  // useEffect(() => {
  //   getBestBid(bestBid?.listingId).then((response) => {
  //   });
  //   getBuyerBidsCountered(bestBid?.listingId).then((response) => {
  //     const buyerBids = response?.data?.counteredBuyerBids[0];
  //     if (response?.data?.status === "SUCCESS") {
  //       const payload = {
  //         bidId: buyerBids?.bidId,
  //         bidPlacedByAgent: buyerBids?.bidPlacedByAgent,
  //         listingId: bestBid?.listingId,
  //         sellerAccountId: user?.sellerId,
  //       };
  //       getPlaceBestBidDetails(payload).then((response) => {
  //         if (response?.data?.statusMessage === "SUCCESS") {
  //           getAvailableBackUpBidAmount(bestBid?.listingId, 0).then(
  //             (response) => {
  //             }
  //           );
  //         }
  //       });
  //     }
  //   });
  //   // Update the previous state for the next render
  //   setPreviousShowState(show);
  // }, [show, bestBid?.listingId]);
  useEffect(() => {
    // Only run when the modal is opened (show changes from false to true)
    if (show && !previousShowState && bestBid?.listingId) {
      getBestBid(bestBid?.listingId).then((response) => {});
      getBuyerBidsCountered(bestBid?.listingId).then((response) => {
        const buyerBids = response?.data?.counteredBuyerBids[0];
        setBuyerBidsUser(buyerBids);
        if (response?.data?.status === "SUCCESS") {
          const payload = {
            bidId: buyerBids?.bidId,
            bidPlacedByAgent: buyerBids?.bidPlacedByAgent,
            listingId: bestBid?.listingId,
            sellerAccountId: user?.sellerId || sellerId,
          };
          getPlaceBestBidDetails(payload).then((response) => {
            console.log("response jjj is", response?.data);
            const nextBidResponse = response?.data;
            setNextBid(nextBidResponse);
            if (response?.data?.statusMessage === "SUCCESS") {
              getAvailableBackUpBidAmount(bestBid?.listingId, 0).then(
                (response) => {
                  // console.log(
                  //   "response plao is",
                  //   response?.data?.data?.possibleBackUpAmount
                  // );
                  setPossibleAmount(response?.data?.data?.possibleBackUpAmount);
                },
              );
            }
          });
        }
      });
      // Update the previous state for the next render
      setPreviousShowState(show);
    } else {
      console.log(
        "API calls NOT triggered because:",
        !show
          ? "modal is closed"
          : previousShowState
            ? "modal was already open"
            : !bestBid?.listingId
              ? "no listing ID"
              : "unknown reason",
      );
    }

    // Update the previous state for the next render
    setPreviousShowState(show);
  }, [show, bestBid?.listingId, previousShowState, user?.sellerId]);
  // Create a function to reset all form values

  // Add a useEffect to reset form values when the modal closes
  useEffect(() => {
    // When the modal is closed (show changes from true to false)
    if (!show && previousShowState) {
      // Reset all form values
      setBidAmount("");
      setDisplayBidAmount("");
      setValidationError("");
      setHoldAsBackup(null);
      setBackupDuration(""); // Or whatever your default value is
      setBuyersPremium({
        buyerPremiumFormatted: "-",
        totalDueFormatted: "-",
      });
    }

    // Update the previous state for the next render
    setPreviousShowState(show);
  }, [show]);
  useEffect(() => {
    if (show) {
      setSubmitSuccess(false);
      setBidAmount("");
      setHoldAsBackup(null);
      setBackupDuration("");
    }
  }, [show]);
  useEffect(() => {
    // You could add additional logic here if needed
  }, [submitSuccess]);
  // Add this function to handle validation
  // const validateBidAmount = async (value) => {
  //   // Clear previous errors
  //   setValidationError("");

  //   // Check if empty
  //   if (!value || value.trim() === "") {
  //     setValidationError("Please enter the bid amount");
  //     return;
  //   }

  //   // Convert to number and validate
  //   const numericValue = parseFloat(value);
  //   if (isNaN(numericValue)) {
  //     setValidationError("Please enter a valid number");
  //     return;
  //   }

  //   setIsValidating(true);
  //   try {
  //     // Call API to validate the bid amount
  //     const response = await getAvailableBackUpBidAmount(
  //       bestBid?.listingId,
  //       numericValue
  //     );
  //     const data = response.data;

  //     // Handle different error codes
  //     if (data.data?.errorCode === "BACKUP_BID_MUST_BE_MULTIPLE_OF_INCREMENT") {
  //       setValidationError(
  //         `Your bid must be in multiples of ${data.data.formattedIncrementMultplier}`
  //       );
  //     } else if (
  //       data.data?.errorCode === "BACKUP_BID_MUST_BE_LESSER_THAN_MAX"
  //     ) {
  //       setValidationError(
  //         `Your bid needs to be equal to or less than the maximum bid of ${data.data.formattedMaxBackUpBidLimit}`
  //       );
  //     } else if (data.data?.errorCode) {
  //       // Handle any other error codes
  //       setValidationError(
  //         data.data.errorCode.replace(/_/g, " ").toLowerCase()
  //       );
  //     }
  //   } catch (error) {
  //     setValidationError("An error occurred while validating your bid");
  //   } finally {
  //     setIsValidating(false);
  //   }
  // };
  // Handle focus - when user clicks on the input, show raw number without $ for editing
  const handleFocus = () => {
    setInputType("number");
    // If there's a value, remove the $ symbol for editing
    if (bidAmount) {
      setDisplayBidAmount(bidAmount);
    }
  };
  // Handle blur - format with $ when user leaves the field
  const handleBlur = async (e) => {
    const value = e.target.value;

    // Store the numeric value without $ for calculations
    if (value) {
      setBidAmount(value);

      // Format with $ for display
      setInputType("text");
      // setDisplayBidAmount(`$${value}`);
      setDisplayBidAmount(`$${parseInt(value).toLocaleString()}`);
    } else {
      // Reset premium values if input is empty
      setBuyersPremium({
        buyerPremiumFormatted: "-",
        totalDueFormatted: "-",
        percentageFormatted: "-",
      });
    }

    // Validate the input
    await validateBidAmount(value);
  };

  // Add this function to handle validation
  const validateBidAmount = async (value) => {
    // Clear previous errors
    setValidationError("");
    // Reset premium values
    setBuyersPremium({
      buyerPremiumFormatted: "-",
      totalDueFormatted: "-",
      percentageFormatted: "-",
    });
    // Check if empty
    if (!value || value.trim() === "") {
      setValidationError("Please enter the bid amount");
      return;
    }

    // Convert to number and validate
    const numericValue = parseFloat(value);
    if (isNaN(numericValue)) {
      setValidationError("Please enter a valid number");
      return;
    }
    // Check if the bid amount matches the nextBidResponse
    const nextBidValue = parseFloat(nextBid?.nextBidResponse);
    if (numericValue !== nextBidValue) {
      // If not equal, keep the premium fields as "-"
      setBuyersPremium({
        buyerPremiumFormatted: "-",
        totalDueFormatted: "-",
        percentageFormatted: "-",
      });
    }
    setIsValidating(true);
    try {
      // Call API to validate the bid amount
      const response = await getAvailableBackUpBidAmount(
        bestBid?.listingId,
        numericValue,
      );
      const data = response.data;

      // Handle different error codes
      if (
        data?.data?.errorCode === "BACKUP_BID_MUST_BE_MULTIPLE_OF_INCREMENT"
      ) {
        setValidationError(
          `Your bid must be in multiples of ${data?.data?.formattedIncrementMultplier}`,
        );
      } else if (
        data?.data?.errorCode === "BACKUP_BID_MUST_BE_LESSER_THAN_MAX"
      ) {
        setValidationError(
          `Your bid needs to be equal to or less than the maximum bid of ${data?.data?.formattedMaxBackUpBidLimit}`,
        );
      } else if (
        data?.data?.errorCode === "HIGHER_BACKUP_BID_AVAILABLE_FOR_USER"
      ) {
        setValidationError(
          `Your backup bid can't be lower than your current bid.`,
        );
      } else if (
        data?.data?.errorCode === "BACKUP_BID_MUST_BE_GREATER_THAN_MIN"
      ) {
        setValidationError(
          // `Your bid needs to be at least $${data?.data?.possibleBackUpAmount}`
          `Your bid needs to be at least $${parseFloat(
            data?.data?.possibleBackUpAmount,
          ).toLocaleString()}`,
        );
      } else if (data?.data?.errorCode) {
        // Handle any other error codes
        setValidationError(
          data.data.errorCode.replace(/_/g, " ").toLowerCase(),
        );
      } else {
        // If no error code, call getBuyersPremium API
        try {
          const premiumResponse = await getBuyerPremium(
            bestBid?.listingId,
            numericValue,
          );
          const premiumData = premiumResponse?.data;

          // Update the buyers premium and total due values
          setBuyersPremium({
            buyerPremiumFormatted: premiumData?.buyerPremiumFormatted || "-",
            totalDueFormatted: premiumData?.totalDueFormatted || "-",
            bidAmountFormatted: premiumData?.bidAmountFormatted || "-",
            percentageFormatted: premiumData?.percentageFormatted || "-",
          });
        } catch (premiumError) {
          // Reset premium values on error
          setBuyersPremium({
            buyerPremiumFormatted: "-",
            totalDueFormatted: "-",
            percentageFormatted: "-",
          });
        }
      }
    } catch (error) {
      setValidationError("An error occurred while validating your bid");
    } finally {
      setIsValidating(false);
    }
  };
  // Handle form submission
  const handleSubmit = async () => {
    // Validate form before submission
    if (!bidAmount) {
      setValidationError("Please enter a bid amount");
      return;
    }

    if (holdAsBackup === null) {
      setValidationError("Please select whether to hold as backup bid");
      return;
    }

    if (holdAsBackup === true && !backupDuration) {
      setValidationError("Please select a backup duration");
      return;
    }

    // Prepare request payload
    const payload = {
      bidId: buyerBidsUser?.bidId,
      listingId: bestBid?.listingId,
      sellerAccountId: user?.sellerId || sellerId, // Default or from data
      bidPlacedByAgent: buyerBidsUser?.bidPlacedByAgent, // Default value, adjust as needed
      buyerResponseAmount: parseFloat(bidAmount),
      backupBidAvailable: holdAsBackup === true ? true : false, // Explicitly convert to boolean
      backupBidExpiryDays: holdAsBackup === true ? backupDuration : null,
    };
    setIsSubmitting(true);
    setValidationError("");

    // try {
    //   // Call the API
    //   const response = await submitPlaceBestBidResponse(payload);
    //   // Check if response is successful
    //   if (
    //     response.statusMessage === "SUCCESS" ||
    //     response.status === "SUCCESS" ||
    //     response.data?.status === "SUCCESS"
    //   ) {
    //     setSubmitSuccess(true);
    //   }
    // } catch (error) {
    //   setValidationError(
    //     "An error occurred while submitting your bid. Please try again."
    //   );
    // } finally {
    //   setIsSubmitting(false);
    // }
    trackButtonClick({
      eventName: "submit_best_bid_click",
      eventCategory: "Best Bid Wizard",
      eventSource: "on best bid click submit",
      eventLabel: `listingId: ${payload.listingId} | bidAmount:${payload.buyerResponseAmount}|backupBidAvailable:${payload.backupBidAvailable}`,
    });
    try {
      // Call the API
      const response = await submitPlaceBestBidResponse(payload);

      // Determine if the response indicates success
      const responseData = response.data || response;
      const isSuccess = responseData.statusMessage === "SUCCESS";

      if (isSuccess) {
        // Update state in a way that ensures React recognizes the change
        setSubmitSuccess(true);
        setValidationError("");

        trackEvent({
          name: "best_bid_placed",
          category: "Best Bid Wizard",
          eventSource: "on best bid click submit success",
          property_type: getPropertyType(bestBid?.propCategoryId),
          seller_id: sellerId,
          bidId: responseData?.bidId,
          listingId: responseData?.listingId,
        });
      } else {
        setValidationError("Failed to submit bid");
        setSubmitSuccess(false);

        trackApiCall({
          eventName: "best_bid_placed_error",
          eventCategory: "Best Bid Wizard",
          eventSource: "on best bid click submit failure",
          eventLabel: `listingId:${payload.listingId}|bidAmount:${payload.buyerResponseAmount}|backupBidAvailable:${payload.backupBidAvailable}`,
        });
      }
    } catch (error) {
      setValidationError(
        "An error occurred while submitting your bid. Please try again.",
      );
      setSubmitSuccess(false);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (!holdAsBackup) {
      setBackupDuration("");
    }
  }, [holdAsBackup]);
  // const MS_PER_DAY = 86400000;

  // const auctionEndTime = useMemo(() => {
  //   const currentDate = bidPageDetail?.bidConfigAttributes?.currentDate;
  //   const timeLeft = propertyToolTip?.listingPriceDetail?.auctionTimeLeft;

  //   if (!currentDate || timeLeft == null) return null;
  //   return timeLeft <= 0 ? currentDate : currentDate + timeLeft;
  // }, [propertyToolTip, bidPageDetail]);

  // const formattedBackupHoldReleaseDate = useMemo(() => {
  //   if (
  //     !auctionEndTime ||
  //     !backupDuration ||
  //     propertyToolTip?.isBidDepositRequired !== "Y"
  //   ) {
  //     return null;
  //   }

  //   const releaseDate = new Date(
  //     auctionEndTime + backupDuration * MS_PER_DAY
  //   );
  //   const months = [
  //     "January", "February", "March", "April", "May", "June",
  //     "July", "August", "September", "October", "November", "December"
  //   ];

  //   return `${months[releaseDate.getMonth()]} ${releaseDate.getDate()}, ${releaseDate.getFullYear()}`;
  // }, [auctionEndTime, backupDuration, propertyToolTip]);

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <p className="best-heading-bid">Place Best Bid</p>
      </Modal.Header>
      <Modal.Body className="moodal-best">
        {!submitSuccess ? (
          <>
            <Form>
              <Row className="mb-3 align-items-center">
                <Col xs={4}>
                  <p className="modal-detail-title-best-bid mb-0">Buyer Name</p>
                </Col>
                <Col xs={4}>
                  <Form.Control
                    className="buyer_nameb formControl-bestBid"
                    type="text"
                    value={
                      buyerBidsUser?.firstName +
                        " " +
                        buyerBidsUser?.lastName || ""
                    }
                    disabled
                  />
                </Col>
              </Row>

              <Form.Group className="mb-3">
                <Row className="align-items-center">
                  <Col xs={4}>
                    <p className="modal-detail-title-best-bid mb-0">
                      Your Bid Amount
                    </p>
                  </Col>
                  <Col xs={4}>
                    <Form.Control
                      className="formControl-bestBid"
                      type={inputType}
                      value={
                        inputType === "number" ? bidAmount : displayBidAmount
                      }
                      onChange={(e) => {
                        const value = e.target.value;
                        if (
                          value === "" ||
                          value.replace(/[^\d]/g, "").length <= 9
                        ) {
                          setBidAmount(e.target.value);
                        }
                      }}
                      // onChange={(e) => {
                      //   const value = e.target.value;
                      //   const numericValue = value.replace(/[^\d]/g, "");

                      //   if (numericValue === "" || numericValue.length <= 9) {
                      //     const formattedValue = numericValue
                      //       ? parseInt(numericValue).toLocaleString()
                      //       : "";
                      //     setBidAmount(formattedValue);
                      //   }
                      // }}
                      // onChange={(e) => {
                      //   const value = e.target.value;
                      //   const numericValue = value.replace(/[^\d]/g, "");

                      //   if (numericValue === "" || numericValue.length <= 9) {
                      //     setBidAmount(numericValue);
                      //   }
                      // }}
                      onFocus={handleFocus}
                      onBlur={handleBlur}
                      disabled={isValidating}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={4}></Col>
                  <Col xs={6}>
                    <Form.Text className="msg-error-best">
                      Place a bid at or above the minimum amount of ${" "}
                      {possibleAmount.toLocaleString()}
                    </Form.Text>
                  </Col>
                </Row>
                <Row>
                  <Col xs={4}></Col>

                  <Col xs={6}>
                    {validationError && (
                      <Form.Text className="text-danger msg-error-best">
                        {validationError}
                      </Form.Text>
                    )}
                  </Col>
                </Row>
              </Form.Group>

              {/* <Row className="mb-3 align-items-center">
                <Col xs={4}>
                  <p className="modal-detail-title-best-bid mb-0">
                    Buyer's premium{" "}
                    {buyersPremium?.percentageFormatted
                      ? ` (${buyersPremium.percentageFormatted})`
                      : ""}
                  </p>
                </Col>
                <Col xs={4}>
                  <Form.Control
                    className="formControl-bestBid"
                    type="text"
                    value={buyersPremium?.buyerPremiumFormatted}
                    disabled
                  />
                </Col>
              </Row> */}
              {nextBid?.premiumPaidBy === "BUYER" && (
                <>
                  {" "}
                  <Row className="mb-3 align-items-center">
                    <Col xs={4}>
                      <p className="modal-detail-title-best-bid mb-0">
                        {bestBid?.propCategoryId === 8
                          ? "Transaction fees"
                          : "Buyer's premium"}{" "}
                        {buyersPremium?.percentageFormatted
                          ? ` (${buyersPremium.percentageFormatted})`
                          : ""}
                      </p>
                    </Col>
                    <Col xs={4}>
                      <Form.Control
                        className="formControl-bestBid"
                        type="text"
                        value={buyersPremium?.buyerPremiumFormatted}
                        disabled
                      />
                    </Col>
                  </Row>
                </>
              )}

              {/* <Row className="mb-3 align-items-center">
                <Col xs={4}>
                  <p className="modal-detail-title-best-bid mb-0">Total Due</p>
                </Col>
                <Col xs={4}>
                  <Form.Control
                    className="formControl-bestBid total-due-best"
                    type="text"
                    value={buyersPremium?.totalDueFormatted}
                    disabled
                  />
                </Col>
              </Row> */}
              <Row className="mb-3 align-items-center">
                <Col xs={4}>
                  <p className="modal-detail-title-best-bid mb-0">Total Due</p>
                </Col>
                <Col xs={4}>
                  <Form.Control
                    className="formControl-bestBid total-due-best"
                    type="text"
                    value={
                      nextBid?.premiumPaidBy === "BUYER"
                        ? buyersPremium?.totalDueFormatted
                        : buyersPremium?.bidAmountFormatted
                    }
                    disabled
                  />
                </Col>
              </Row>

              <BackupBidSection
                nextBid={{ backupBidExpiryDaysList: [10, 15, 30] }}
                propertyToolTip={{
                  isBidDepositRequired:
                    nextBid?.isBidDepositRequired === "Y" ? "Y" : "N",
                  listingPriceDetail: { auctionTimeLeft: -51492322996 },
                }}
                holdAsBackup={holdAsBackup}
                setHoldAsBackup={setHoldAsBackup}
                backupDuration={backupDuration}
                setBackupDuration={setBackupDuration}
              />
            </Form>
          </> // Success message
        ) : (
          <div className="text-center py-4">
            <div className="d-flex ">
              {" "}
              <p className="buyr-bestbid">Buyer Name</p>
              <p style={{ marginLeft: "9rem" }}>
                {buyerBidsUser?.firstName} {buyerBidsUser?.lastName}
              </p>
            </div>

            <div className=" mt-4">
              <h4>Thank you for your bid.</h4>
            </div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer
        className="justify-content-between"
        style={{ marginLeft: "0.5rem" }}
      >
        {!submitSuccess ? (
          <>
            {/* <Button
              variant="secondary"
              onClick={onHide}
              disabled={isSubmitting}
            >
              Cancel
            </Button> */}
            <Button
              variant="primary"
              onClick={handleSubmit}
              className="submit-best-bid"
              disabled={
                isSubmitting ||
                !bidAmount ||
                holdAsBackup === null ||
                (holdAsBackup === true && !backupDuration)
              }
            >
              {isSubmitting ? "Submitting..." : "Submit"}
            </Button>
          </>
        ) : (
          <Button
            className="successss-bestbidbutton"
            variant="primary"
            onClick={onHide}
          >
            Close
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default BestBidModal;
